<template>
    <div class="vh-100 bg-grey">
        <!-- HEADER -->
        <div class="header-top bg-white">

            <!-- Normal Header -->
            <div id="normalHeader" class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left">
                    <div class="header-item" @click="RouteToDashboard">
                        <div class="header-icon icon-arrow-left"></div>
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">
                    Notifikasi
                </div>
                <div class="header-top--right">
                    <div class="header-item">
                        <div class="header-icon icon-search-blue" @click="changeHeader('toSearchHeader')"></div>
                    </div>
                </div>
            </div>

            <!--  Header for Search -->
            <div id="searchHeader"
                 class="display-none header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left">
                    <input style="padding-left: 20px;" class="inputSearch" id="searchInputs" v-model="searchInputs"
                           v-on:keyup="serachDelayKeyup" type="text" placeholder="Cari..">
                </div>
                <div class="header-top--right">
                    <div class="header-item">
                        <div class="header-icon icon-close-search-blue" @click="changeHeader('toNormalHeader')"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MAIN NORMAL CONTENT -->
        <main class="page-wrapper main-page">
            <div id="listNotification">

                <!-- SEARCH INDICATOR -->
                <div class="b-d" v-if="show_search_notice == true">
                    <div class="w-limit p-x-20 p-y-12 notice">
                        {{ search_notice }}
                    </div>
                    <div class="boxAlert" id="dataTidakDitemukan">
                        <div class="circleAlert"></div>
                        <div class="textCLoseAlert">
                            Periksa lagi kata yang anda ketik, atau coba dengan kata lainya...
                        </div>
                    </div>
                </div>

                <!-- FILTER -->
                <div id="containt_data">
                    <div class="bg-white b-d" v-if="show_filter == true">
                        <div class="w-limit p-x-20 p-y-12">
                            <a class="f-16 f-semi f-c-blue dropdown-toggle" href="#" data-toggle="dropdown">
                                Tampilkan: <span>{{ categoryTitle }}</span>
                            </a>
                            <div class="dropdown-menu mod">
                                <div class="dropdown-item plain">Tampilkan:</div>
                                <a class="dropdown-item active" id="categorySemua" @click="changeCategory('semua')"
                                   href="#">Semua</a>
                                <div class="separator-line"></div>
                                <a class="dropdown-item" id="categoryPemberitahuan"
                                   @click="changeCategory('pemberitahuan')"
                                   href="#">Pemberitahuan</a>
	                            <a class="dropdown-item" id="categorySetoran"
	                               @click="changeCategory('setoran')" href="#">Setoran</a>
                                <a class="dropdown-item" id="categoryPembatalan" @click="changeCategory('pembatalan')"
                                   href="#">Penghapusan</a>
	                            <a class="dropdown-item" id="categoryKasLaci"
	                               @click="changeCategory('kas_laci')" href="#">Permintaan Kas Laci</a>
                                <a class="dropdown-item" id="categoryPermintaanBiaya"
                                   @click="changeCategory('permintaan_biaya')" href="#">Permintaan
                                    Biaya</a>
                                <a class="dropdown-item" id="categoryButuhKonfirmasi"
                                   @click="changeCategory('butuh_konfirmasi')" href="#">Butuh Konfirmasi</a>
                            </div>
                        </div>
                    </div>

                    <div class="boxAlert" id="dataKosong">
                        <div class="notifAlert"></div>
                        <div class="textCLoseAlert">
                            Notifikasi anda akan tampil disini.
                        </div>
                    </div>

                    <div class="w-limit">
                        <!-- UNREAD NOTIFICATION -->
                        <div v-if="notificationListUnseen.length > 0">
                            <div class="col-md-12 col-sm-12 col-xs-12 xol-12">
                                <div class="p-y-16 f-c-midgrey">Belum dibaca / Perlu konfirmasi ({{
                                    notificationListUnseen.length }})
                                </div>
                                <div class="p-y-16 f-semi f-c-blue btn-sm-mark" v-if="category === 'pemberitahuan'">
                                    <button type="button" @click="marksAllUnseenNotifications"
                                            class="btn btn-outline-primary btn-sm btnTandai bg-white">
                                        <img class="checkIcon" src="../../assets/icons/check.svg" alt="">
                                        Tandai terbaca semua
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="unread-notif-wrapper">
                            <div class="notif-item" v-for="eachUnseen in notificationListUnseen" :key="eachUnseen.id">
                                <div v-if="eachUnseen.category == 'pembatalan'"
                                     @click="routePembatalan(eachUnseen.action_url)">
                                    <div class="d-flex-between-center">
                                        <div class="notif-type yellow dot">
                                            Penghapusan
                                        </div>
                                        <div class="f-12 f-c-muted">{{ eachUnseen.time }}</div>
                                    </div>
                                    <div class="f-16 m-t-4 f-bold">{{ eachUnseen.title }}</div>
                                    <div class="f-12 f-c-asgrey m-t-4 max title">{{ eachUnseen.body }}</div>
                                </div>
                                <div v-if="eachUnseen.category == 'permintaan_biaya'"
                                     @click="routeBiaya(eachUnseen.action_url)">
                                    <div class="d-flex-between-center">
                                        <div class="notif-type red dot">
                                            Permintaan Biaya
                                        </div>
                                        <div class="f-12 f-c-muted">{{ eachUnseen.time }}</div>
                                    </div>
                                    <div class="f-16 m-t-4 f-bold">{{ eachUnseen.title }}</div>
                                    <div class="f-12 f-c-asgrey m-t-4 max title">{{ eachUnseen.body }}</div>
                                </div>
                                <div v-if="eachUnseen.category == 'pemberitahuan'"
                                     @click="routePemberitahuan(eachUnseen.id)">
                                    <div class="d-flex-between-center">
                                        <div class="notif-type blue dot">
                                            Pemberitahuan
                                        </div>
                                        <div class="f-12 f-c-muted">{{ eachUnseen.time }}</div>
                                    </div>
                                    <div class="f-16 m-t-4 f-bold">{{ eachUnseen.title }}</div>
                                    <div class="f-12 f-c-asgrey m-t-4 max title">{{ eachUnseen.body }}</div>
                                </div>
                                <div v-if="eachUnseen.category == 'invoice'"
                                     @click="routeInvoice(eachUnseen)">
                                    <div class="d-flex-between-center">
                                        <div class="notif-type blue dot">
                                            Permintaaan
                                        </div>
                                        <div class="f-12 f-c-muted">{{ eachUnseen.time }}</div>
                                    </div>
                                    <div class="f-16 m-t-4 f-bold">{{ eachUnseen.title }}</div>
                                    <div class="f-12 f-c-asgrey m-t-4 max title">{{ eachUnseen.body }}</div>
                                </div>
                                <div v-if="eachUnseen.category == 'kas_laci'"
                                     @click="routeKasLaci(eachUnseen.action_url)">
                                    <div class="d-flex-between-center">
                                        <div class="notif-type green dot">
                                            Kas Laci
                                        </div>
                                        <div class="f-12 f-c-muted">{{ eachUnseen.time }}</div>
                                    </div>
                                    <div class="f-16 m-t-4 f-bold">{{ eachUnseen.title }}</div>
                                    <div class="f-12 f-c-asgrey m-t-4 max title">{{ eachUnseen.body }}</div>
                                </div>
                                <div v-if="eachUnseen.category == 'setoran'"
                                     @click="routeSetoran(eachUnseen.action_url)">
                                    <div class="d-flex-between-center">
                                        <div class="notif-type green dot">
                                            Setoran
                                        </div>
                                        <div class="f-12 f-c-muted">{{ eachUnseen.time }}</div>
                                    </div>
                                    <div class="f-16 m-t-4 f-bold">{{ eachUnseen.title }}</div>
                                    <div class="f-12 f-c-asgrey m-t-4 max title">{{ eachUnseen.body }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- READ NOTIFICATION -->
                        <div class="p-x-20 p-y-16" v-if="notificationListSeen.length > 0">
                            <div class="f-16 f-c-midgrey">Telah dibaca / Telah dikonfirmasi</div>
                        </div>
                        <div class="read-notif-wrapper">
                            <div class="notif-item" v-for="eachData in notificationListSeen" :key="eachData.id">
                                <div v-if="eachData.category == 'pembatalan'"
                                     @click="routePembatalan(eachData.action_url)">
                                    <div class="d-flex-between-center">
                                        <div class="notif-type yellow">
                                            Pembatalan
                                        </div>
                                        <div class="f-12 f-c-muted">{{ eachData.time }}</div>
                                    </div>
                                    <div class="f-16 m-t-4 f-c-asgrey f-bold">{{ eachData.title }}</div>
                                    <div class="f-12 f-c-asgrey2 m-t-4 max title">{{ eachData.body }}</div>
                                </div>
                                <div v-if="eachData.category == 'permintaan_biaya'"
                                     @click="routeBiaya(eachData.action_url)">
                                    <div class="d-flex-between-center">
                                        <div class="notif-type red">
                                            Permintaan Biaya
                                        </div>
                                        <div class="f-12 f-c-muted">{{ eachData.time }}</div>
                                    </div>
                                    <div class="f-16 m-t-4 f-c-asgrey f-bold">{{ eachData.title }}</div>
                                    <div class="f-12 f-c-asgrey2 m-t-4 max title">{{ eachData.body }}</div>
                                </div>
                                <div v-if="eachData.category == 'pemberitahuan'"
                                     @click="routePemberitahuan(eachData.id)">
                                    <div class="d-flex-between-center">
                                        <div class="notif-type blue">
                                            Pemberitahuan
                                        </div>
                                        <div class="f-12 f-c-muted">{{ eachData.time }}</div>
                                    </div>
                                    <div class="f-16 m-t-4 f-c-asgrey f-bold">{{ eachData.title }}</div>
                                    <div class="f-12 f-c-asgrey2 m-t-4 max title">{{ eachData.body }}</div>
                                </div>
                                <div v-if="eachData.category == 'kas_laci'" @click="routeKasLaci(eachData.action_url)">
                                    <div class="d-flex-between-center">
                                        <div class="notif-type green">
                                            Kas Laci
                                        </div>
                                        <div class="f-12 f-c-muted">{{ eachData.time }}</div>
                                    </div>
                                    <div class="f-16 m-t-4 f-c-asgrey f-bold">{{ eachData.title }}</div>
                                    <div class="f-12 f-c-asgrey2 m-t-4 max title">{{ eachData.body }}</div>
                                </div>
                                <div v-if="eachData.category == 'setoran'" @click="routeSetoran(eachData.action_url)">
                                    <div class="d-flex-between-center">
                                        <div class="notif-type green">
                                            Setoran
                                        </div>
                                        <div class="f-12 f-c-muted">{{ eachData.time }}</div>
                                    </div>
                                    <div class="f-16 m-t-4 f-c-asgrey f-bold">{{ eachData.title }}</div>
                                    <div class="f-12 f-c-asgrey2 m-t-4 max title">{{ eachData.body }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="loadmoreSpinner" id="loadingSpinner">
                    <center>
                        <div class="sp sp-circle"></div>
                    </center>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import Popup from "../../component-items/Popup";

    export default {
        name: "Notification",
        components: {
            'Popup': Popup,
        },
        data() {
            return {
                show_search_notice: false,
                show_filter: false,
                search_notice: '',
                page_number: 0,
                limit_data: 10,
                length_data: 0,
                offset_data: 0,
                params_header: 'toNormalHeader',
                searchInputs: '',
                category: 'semua',
                categoryTitle: 'Semua',
                notificationListSeen: [],
                notificationListUnseen: [],
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
                search: false,
                methodSearchCalled: false,
            }
        },
        mounted() {
            $('#dataTidakDitemukan').hide();
            $('#dataKosong').show();
            $('#loadingSpinner').show();
            this.scroll();
            this.GetDataNotificationList();
            this.smartTrackingClick('notifikasi')

        },
        methods: {
            toTop() {
                window.scrollTo(0, 0)
            },
            changeHeader(params) {
                if (params == "toSearchHeader") {
                    $("#searchHeader").removeClass("display-none");
                    $("#normalHeader").addClass("display-none");
                    $("#searchInputs").focus()
                    $("#containt_data").hide()

                    this.notificationListSeen = []
                    this.notificationListUnseen = []
                    this.offset_data = 0
                    this.length_data = 0
                    this.page_number = 0

                    this.search = true;
                    this.GetDataNotificationList(this.search);
                } else {
                    $("#containt_data").show()
                    $("#normalHeader").removeClass("display-none");
                    $("#searchHeader").addClass("display-none");
                    $("#searchInputs").blur()
                    this.notificationListSeen = []
                    this.notificationListUnseen = []
                    this.offset_data = 0
                    this.length_data = 0
                    this.page_number = 0
                    this.show_search_notice = false
                    this.show_filter = true
                    this.searchInputs = ''

                    this.search = false;
                    this.methodSearchCalled = false;
                    this.category = 'semua'
                    this.changeCategory(this.category)
                    this.GetDataNotificationList(this.search);
                }
            },
            RouteToDashboard() {
                this.$emit("ToChildDashboard")
            },
            scroll() {
                window.onscroll = () => {
                    if ($('#loadingSpinner').is(":hidden")) {
                        if ($("#listNotification").is(":visible")) {
                            if (this.page_number <= Math.ceil(this.length_data / this.limit_data)) {
                                if (Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height())) {
                                    var offset = (this.page_number * this.limit_data);
                                    this.offset_data = offset;
                                    this.GetDataNotificationList();
                                }
                            }
                        }
                    }
                };
            },
            serachDelayKeyup() {
                this.notificationListSeen = []
                this.notificationListUnseen = []
                this.offset_data = 0
                this.length_data = 0
                this.page_number = 0
                if (this.searchInputs.length > 2) {
                    if (this.timer) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    this.timer = setTimeout(() => {
                        $(".spinner").prop("style", "display:inline-block");
                        this.notificationListSeen = []
                        this.notificationListUnseen = []
                        this.GetDataNotificationList()
                    }, 700);
                } else {
                    $("#dataTidakDitemukan").hide()
                    this.show_search_notice = true
                    this.show_filter = false
                    this.search_notice = "Minimal 3 karakter";
                }
            },
            changeCategory(params) {
                $(".dropdown-item").removeClass("active")
                switch (params) {
                    case "pemberitahuan":
                        this.categoryTitle = "Pemberitahuan"
                        this.category = 'pemberitahuan'
                        $("#categoryPemberitahuan").addClass("active")
                        break;
                    case "pembatalan":
                        this.categoryTitle = "Pembatalan"
                        this.category = 'pembatalan'
                        $("#categoryPembatalan").addClass("active")
                        break;
                    case "kas_laci":
                        this.categoryTitle = "Kas Laci"
                        this.category = 'kas_laci'
                        $("#categoryKasLaci").addClass("active")
                        break;
                    case "setoran":
                        this.categoryTitle = "Setoran"
                        this.category = 'setoran'
                        $("#categorySetoran").addClass("active")
                        break;
                    case "permintaan_biaya":
                        this.categoryTitle = "Permintaan Biaya"
                        this.category = 'permintaan_biaya'
                        $("#categoryPermintaanBiaya").addClass("active")
                        break;
                    case "butuh_konfirmasi":
                        this.categoryTitle = "Butuh Konfirmasi"
                        this.category = 'butuh_konfirmasi'
                        $("#categoryButuhKonfirmasi").addClass("active")
                        break;
                    default:
                        this.categoryTitle = "Semua"
                        this.category = 'semua'
                        $("#categorySemua").addClass("active")
                }
                this.notificationListSeen = []
                this.notificationListUnseen = []
                this.offset_data = 0
                this.length_data = 0
                this.page_number = 0
                this.GetDataNotificationList()
            },
            routePemberitahuan(params) {
                this.$router.push({
                    name: "ibos",
                    query: {part: 'notification', params: 'id=' + params, label: 'Detail Notification'}
                });
            },
            routeInvoice(params) {
                let linkUrl = params.action_url.split("/");

                if (params.type === "pembatalan_invoice") {
                    this.$router.push({ name:"invoice.detail", params: { invoiceId: linkUrl[5] } })
                }
            },
            routeKasLaci(params) {
                var explode = params.split("/");

                let oldData = explode[2] === "boss.smartlink.id";
                let idData = explode[explode.length - 1]
                let isOutlet = explode[explode.length - 3] === "permintaan-kas-outlet";

                if (oldData) {
                  let data = idData.split("?");

                  this.$router.push({ path: `${data[0] === 'outlet' ? 'permintaan-kas-outlet' : 'permintaan-kas-workshop'}/detail/${data[1].replace('id=', '')}` })
                } else {
                  this.$router.push({ path: `${isOutlet? 'permintaan-kas-outlet' : 'permintaan-kas-workshop'}/detail/${idData}` })
                }

            },
            routeSetoran(params) {
                var explode = params.split("/");

                let oldData = explode[2] === "boss.smartlink.id";
                let idData = explode[explode.length - 1]
                let isOutlet = explode[explode.length - 3] === "setoran-kas-outlet";

                if (oldData) {
                  let data = idData.split("?");

                  this.$router.push({ path: `${data[0] === 'outlet' ? 'setoran-kas-outlet' : 'setoran-kas-workshop'}/detail/${data[1].replace('id=', '')}` })
                } else {
                  this.$router.push({ path: `${isOutlet? 'setoran-kas-outlet' : 'setoran-kas-workshop'}/detail/${idData}` })
                }
            },
            routeBiaya(params) {
                var explode = params.split("/");

                let oldData = explode[2] === "boss.smartlink.id";
                let idData = explode[explode.length - 1]
                let isOutlet = explode[explode.length - 3] === "biaya-outlet";

                if (oldData) {
                  let data = idData.split("?");

                  this.$router.push({ path: `${data[0] === 'outlet'? 'biaya-outlet' : 'biaya-workshop'}/detail/${data[1].replace('id=', '')}` })
                } else {
                  this.$router.push({ path: `${isOutlet? 'biaya-outlet' : 'biaya-workshop'}/detail/${idData}` })
                }

            },
            routePembatalan(params) {
                var explode = params.split("/");
                var pathLocation = explode[explode.length - 1]
                var typePembatalan = explode[explode.length - 2]
                var explodeLocation = pathLocation.split("?");
                var explodeParams = explodeLocation[1].split("=");
                var idNotif = explodeParams[1]
                if (typePembatalan == "pembatalan_emoney"){
                    if (explodeLocation[0] == "outlet") {
                        this.$router.push({
                            path:"pembatalan_topup_epayment/detail/"+idNotif
                        })
                    } else {
                        this.$router.push({
                            name: "ibos",
                            query: {
                                part: 'transaksi/pembatalan_emoney/workshop',
                                params: 'id=' + idNotif,
                                label: 'Detail Notification'
                            }
                        });
                    }
                }else if (typePembatalan == "pembatalan_deposit"){
                    if (explodeLocation[0] == "outlet") {
                        this.$router.push({
                            path:"pembatalan_topup_deposit/detail/"+idNotif
                        })
                    } else {
                        this.$router.push({
                            name: "ibos",
                            query: {
                                part: 'transaksi/pembatalan_deposit/workshop',
                                params: 'id=' + idNotif,
                                label: 'Detail Notification'
                            }
                        });
                    }
                }else{
                    if (explodeLocation[0] == "outlet") {
                        this.$router.push({
                            path:"pembatalan_transaksi_reguler/detail/"+idNotif
                        })
                    } else {
                        this.$router.push({
                            name: "ibos",
                            query: {
                                part: 'transaksi/pembatalan/workshop',
                                params: 'id=' + idNotif,
                                label: 'Detail Notification'
                            }
                        });
                    }
                }
            },
            async GetDataNotificationList(checkSearch = false) {
                if (this.methodSearchCalled) {
                    this.methodSearchCalled = false;
                    return;
                }

                this.methodSearchCalled = true;
                if (checkSearch && this.offset_data === 0) {
                    return;
                } else if (this.offset_data === 0) {
                    this.search = false
                }
                var category = ''
                if (this.category != 'semua') {
                    category = this.category
                }
                var keySearch = ''
                if (this.searchInputs.length > 2) {
                    keySearch = this.searchInputs
                }

                $("#dataTidakDitemukan").hide()
                $('#loadingSpinner').show()

                try {
                    var response = await this.$axios.get(this.$baseurl + 'masterData/meta/list_notifikasi_owner?limit=' + this.limit_data + '&offset=' + this.offset_data + '&kategori=' + category + '&key=' + keySearch, this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            var contentData = response.data.data

                            // handle search null
                            if (this.searchInputs.length > 2) {
                                $("#containt_data").hide()
                                if ((contentData.length == 0 || contentData.length == undefined) && this.category == 'semua') {
                                    this.show_filter = false
                                    this.show_search_notice = true
                                    this.search_notice = 'Tidak menemukan "' + this.searchInputs + '"';
                                    $("#dataTidakDitemukan").show()
                                    $('#dataKosong').hide();
                                    $("#containt_data").hide()
                                } else {
                                    this.show_search_notice = false
                                    this.show_filter = true
                                    $("#dataTidakDitemukan").hide()
                                    $("#containt_data").show()
                                }
                            } else {
                                if (contentData.lenght == 0 || contentData.length == undefined) {
                                    this.show_filter = false
                                    $("#dataKosong").show()
                                } else {

                                    this.show_filter = true
                                    $("#dataKosong").hide()
                                }
                            }

                            // looping data if not null
                            $("#containt_data").show()
                            for (var i = 0; i < contentData.length; i++) {
                                this.length_data = this.length_data + 1
                                var dataJson = contentData[i].data;
                                var objData = JSON.parse(dataJson)
                                var categoryType = this.typeCondition(contentData[i].type)
                                if (contentData[i].is_read == 0) {
                                    this.notificationListUnseen.push({
                                        id: contentData[i].id,
                                        type: objData["related_type"],
                                        title: objData["title"],
                                        body: objData["body"],
                                        action_url: objData["action_url"],
                                        seen: contentData[i].is_read,
                                        time: this.helperTimeAgo(contentData[i].created_at),
                                        category: categoryType,
                                    })
                                } else {
                                    if (contentData[i].is_action === 0 && contentData[i].need_action === 1) {
                                        this.notificationListUnseen.push({
                                            id: contentData[i].id,
                                            type: objData["related_type"],
                                            title: objData["title"],
                                            body: objData["body"],
                                            action_url: objData["action_url"],
                                            seen: contentData[i].is_read,
                                            time: this.helperTimeAgo(contentData[i].created_at),
                                            category: categoryType,
                                        })
                                    } else {
                                        this.notificationListSeen.push({
                                            id: contentData[i].id,
                                            type: objData["related_type"],
                                            title: objData["title"],
                                            body: objData["body"],
                                            action_url: objData["action_url"],
                                            seen: contentData[i].is_read,
                                            time: this.helperTimeAgo(contentData[i].created_at),
                                            category: categoryType,
                                        })
                                    }
                                }
                            }
                            this.page_number = this.page_number + 1
                            $('#loadingSpinner').removeClass('overlayLoading');
                            $('#loadingSpinner').hide()
                            this.methodSearchCalled = false;
                        } else {
                            this.popupType = "error";
                            this.popupMessage = response.data.msg;

                            $('#loadingSpinner').removeClass('overlayLoading');
                            $('#loadingSpinner').hide()
                        }
                    }
                } catch (e) {
                    this.popupType = "error"
                    this.popupErrorException = e

                    $('#loadingSpinner').removeClass('overlayLoading');
                    $('#loadingSpinner').hide()
                }
            },
            typeCondition(params) {
                switch (params) {
                    case "App\\Notifications\\Pengumuman":
                        return "pemberitahuan"
                        break;
                    case "App\\Notifications\\KoinHabis":
                        return "pemberitahuan"
                        break;
                    case "App\\Notifications\\WhatsappOffline":
                        return "pemberitahuan"
                        break;
                    case "App\\Notifications\\PembatalanTransaksi":
                        return "pembatalan"
                        break;
                    case "App\\Notifications\\PembatalanDeposit":
                        return "pembatalan"
                        break;
                    case "App\\Notifications\\PembatalanEmoney":
                        return "pembatalan"
                        break;
                    case "App\\Notifications\\BiayaOutlet":
                        return "permintaan_biaya"
                        break;
                    case "App\\Notifications\\BiayaWorkshop":
                        return "permintaan_biaya"
                        break;
                    case "App\\Notifications\\SetoranOutlet":
                        return "setoran"
                        break;
                    case "App\\Notifications\\SetoranWorkshop":
                        return "setoran"
                        break;
                    case "App\\Notifications\\TransferOutlet":
                        return "kas_laci"
                        break;
                    case "App\\Notifications\\TransferWorkshop":
                        return "kas_laci"
                    case "App\\Notifications\\PembatalanInvoice":
                        return "invoice"
                        break;
                    default:
                        return "pemberitahuan"
                }
            },
            helperTimeAgo(dateParam) {
                if (!dateParam) {
                    return null;
                }
                const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam);
                const today = new Date();
                const seconds = Math.round((today - date) / 1000);
                const minutes = Math.round(seconds / 60);
                const hours = Math.round(minutes / 60);
                const isOnWeek = Math.round(hours / 24);
                const isThisYear = today.getFullYear() === date.getFullYear();

                if (seconds < 15) {
                    return 'Baru saja';
                } else if (seconds < 60) {
                    return `${seconds} Detik`;
                } else if (minutes < 60) {
                    return `${minutes} Menit`;
                } else if (hours < 24) {
                    return `${hours} Jam`;
                } else if (isOnWeek < 8) {
                    return `${isOnWeek} Hari`;
                } else if (isThisYear) {
                    return this.getFormattedDate(date, false, false);
                } else {
                    return this.getFormattedDate(date);
                }
            },
            getFormattedDate(date, prefomattedDate = false, hideYear = false) {
                const MONTH_NAMES = [
                    'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
                    'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
                ];
                const day = date.getDate();
                const month = MONTH_NAMES[date.getMonth()];
                const year = date.getFullYear();

                if (prefomattedDate) {
                    return `${prefomattedDate} yang lalu`;
                }

                if (hideYear) {
                    return `${day} ${month}`;
                }

                return `${day} ${month} ${year}`;
            },
            async marksAllUnseenNotifications() {
                const forms = new FormData();
                try {
                    const response = await this.$axios.post(this.$baseurl + '/masterData/dashboard/tandai_semua_notifikasi_terbaca', forms, this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.notificationListSeen = []
                            this.notificationListUnseen = []
                            this.offset_data = 0
                            this.length_data = 0
                            this.page_number = 0
                            this.GetDataNotificationList()
                        } else {
                            this.popupType = "error";
                            this.popupMessage = response.data.msg;
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    this.popupType = "error";
                    this.popupErrorException = e;
                }
            },
        }
    }
</script>
<style scoped>
    .icon-close-search-blue {
        background-image: url(../../assets/img/x2.svg)
    }

    .boxAlert {
        margin: 150px auto;
    }

    .textCLoseAlert {
        width: 250px;
        text-align: center;
        margin: 10px auto;
        font-family: Overpass;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        letter-spacing: -0.02em;
        color: #808080;
    }

    .notifAlert {
        margin: 0 auto;
        height: 110px;
        width: 110px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url(../../assets/icons/bellalert.svg)
    }

    .circleAlert {
        margin: 0 auto;
        height: 110px;
        width: 110px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url(../../assets/icons/closeCircle.svg)
    }

    .sp-circle {
        width: 30px;
        height: 30px;
        border: 4px rgba(172, 160, 160, 0.27) solid;
        border-top: 4px #b5b5b5 solid;
        border-radius: 50%;
        -webkit-animation: spCircRot .6s infinite linear;
        animation: spCircRot .6s infinite linear;
    }

    @-webkit-keyframes spCircRot {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(359deg);
        }
    }

    @keyframes spCircRot {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(359deg);
        }
    }

    .display-none {
        display: none !important;
    }

    .notice {
        font-family: Overpass;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 155%;
        display: flex;
        align-items: center;
        letter-spacing: -0.02em;
        color: #6F7287;
    }

    .loadmoreSpinner {
        padding: 15px 0px;
        width: 100%;
        height: 80px;
    }

    .max.title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .notif-item {
        padding: 12px 20px;
        background: white;
    }

    .notif-item:not(:first-child) {
        margin-top: 2px;
    }

    .notif-item .notif-type {
        font-size: 12px;
        letter-spacing: -0.02em;
    }

    .notif-item .notif-type.green {
        color: #8CC07F;
    }

    .notif-item .notif-type.red {
        color: #EE7277;
    }

    .notif-item .notif-type.yellow {
        color: #EEB711;
    }

    .notif-item .notif-type.blue {
        color: #4A85FF;
    }

    .notif-item .notif-type.purple {
        color: #e03cff;
    }

    .notif-item .notif-type.dot {
        display: flex;
        align-items: center;
        font-weight: bold !important;
    }

    .notif-item .notif-type.dot:before {
        content: '';
        width: 6px;
        height: 6px;
        background-color: #ededed;
        margin-right: 6px;
        margin-top: -3px;
        border-radius: 50%;
    }

    .checkIcon {
        margin-top: -1px;
        margin-right: 3px;
        margin-left: 3px;
        width: 13px;
    }

    .notif-item .notif-type.dot.green:before {
        background-color: #8CC07F;
    }

    .notif-item .notif-type.dot.red:before {
        background-color: #EE7277;
    }

    .notif-item .notif-type.dot.yellow:before {
        background-color: #EEB711;
    }

    .notif-item .notif-type.dot.blue:before {
        background-color: #4A85FF;
    }

    .notif-item .notif-type.dot.purple:before {
        background-color: #e03cff;
    }

    .btn-sm-mark {
        margin-top: -20px;
    }

    .btnTandai {
        border-color: #206CFF;
        color: #206CFF;
        -webkit-box-flex: 0;
        -ms-flex: none;
        flex: none;
        -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
        order: 1;
        -ms-flex-item-align: center;
        align-self: center;
        -ms-flex-positive: 0;
        flex-grow: 0;
        margin: 4px 0px;
        padding-right: 13px;
        padding-top: 6px;
        padding-bottom: 6px;
    }

    .f-c-asgrey {
        color: #787878 !important;
    }

    .f-c-asgrey2 {
        color: #aaaaaa !important;
    }

    @keyframes puls {
        from {
            opacity: 1;
            transform: scale(0);
        }

        to {
            opacity: 0;
            transform: scale(2);
        }
    }
</style>